import { render, staticRenderFns } from "./driverList.vue?vue&type=template&id=90d3ad56&scoped=true&"
import script from "./driverList.vue?vue&type=script&lang=js&"
export * from "./driverList.vue?vue&type=script&lang=js&"
import style0 from "./driverList.vue?vue&type=style&index=0&id=90d3ad56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d3ad56",
  null
  
)

export default component.exports